/* LOAD CUSTOM COIN PRODUCT DATA */
const PRODUCT_HANDLE = '40mm-objective-coins-custom';

window.__product_customCoins = {_base: null,  _quantities: []};
async function loadCustomCoinProduct() {
  const res = await fetch(`/products/${PRODUCT_HANDLE}.js`, {headers: { 'Accept': 'application/json' }});
  if (!res.ok) throw new Error('Failed to load product');
  const product = await res.json();
  product.variants.forEach((v, idx) => {
    const qty = parseInt(v.option1, 10);
    if (idx === 0) __product_customCoins._base = { id: v.id };
    __product_customCoins[qty] = {id: v.id,title: v.title,option1: v.option1,price: v.price};
  });
  __product_customCoins._quantities = Object.keys(__product_customCoins).filter(k => k !== '_base' && k !== '_quantities').map(k => parseInt(k, 10)).sort((a, b) => a - b);
  initCoinSlider();
  initAddToCartButton();
  return product;
}
loadCustomCoinProduct() // i.e.   __product_customCoins.100: {id: 51040463421757, title: '100', option1: '100', price: 69500}

// Wire the Quantity Slider
function initCoinSlider() {
  const priceLabel = document.getElementById('coin-price-label');
  const slider = document.getElementById('qty');
  const qtyLabel = document.getElementById('qty-label');
  const quantities = __product_customCoins._quantities;
  if (!slider || !qtyLabel || !priceLabel || !quantities.length) return;
  slider.min = 0;
  slider.max = quantities.length - 1;
  slider.step = 1;
  slider.value = 0;
  function updateFromSlider() {
    const idx = parseInt(slider.value, 10);
    const qty = quantities[idx];
    const variant = __product_customCoins[qty];
    qtyLabel.textContent = `${qty} coins`;
    // price is in cents
    const dollars = (variant.price / 100).toFixed(2);
    priceLabel.textContent = `$${dollars}`;
  }
  slider.addEventListener('input', updateFromSlider);
  updateFromSlider();
}
// Wire the Button
function getSelectedVariantFromSlider() {
  const slider = document.getElementById('qty');
  const quantities = __product_customCoins._quantities;
  if (!slider || !quantities.length) return null;
  const idx = parseInt(slider.value, 10);
  const qty = quantities[idx];
  const variant = __product_customCoins[qty];
  return { qty, variant };
}
function initAddToCartButton_orig() {
  const btn = document.getElementById('add2cart');
  if (!btn) return;

  btn.addEventListener('click', async () => {
    const sel = getSelectedVariantFromSlider();
    if (!sel || !sel.variant) return;

    if (!window.orderData) window.orderData = {};
    window.orderData.quantity = sel.qty;

    try {
              try {
        await handleUploads();                    // logo + 2 snaps → d.uploadURLs
      } catch (e) {
        console.warn('Upload issue:', e);alert('failed')
      }
      const props = buildForgeProperties();
      await addToCart(sel.variant.id, 1, props);
    } catch (err) {
      console.error('Add to Cart failed:', err);
    }
  });
}
document.getElementById('add2cart-tape').addEventListener('click',()=>{addToCart(50872716820797,1,null);run2cart()})

const run2cart = () => alert('Added to cart!');

// Build the Order Data:
function buildForgeProperties() {
  const d = window.orderData || {};
  const base = d.basePaint || {};
  const logo = d.logo || {};
  const img  = d.img  || {};

  const baseColors = [base.colorA, base.colorB, base.colorC].filter(c => c && c !== 'null');
  const logoColors = [logo.colorA, logo.colorB].filter(c => c && c !== 'null');

  const material =
    typeof d.material === 'string' && d.material.length
      ? d.material.charAt(0).toUpperCase() + d.material.slice(1)
      : '';

  const payload = {
    product: d.product,
    diameter: d.diameter,
    thickness: d.thickness,
    material: d.material,
    basePaint: base,
    logo,
    quantity: d.quantity,
    // img: {
    //   screenshot1: img.screenshot1 || null,
    //   screenshot2: img.screenshot2 || null
    // }
  };

  const props = { _forge_payload: JSON.stringify(payload) };

  if (material) props['Forge Material'] = material;

  if (baseColors.length > 0) {
    if (!base.pattern || base.pattern === 'None') {
      props['Base Color'] = String(baseColors[0]);
    } else {
      props['Base Color'] = baseColors.join(' | ');
    }
  }

  if (base.pattern && base.pattern !== 'None') props['Base Pattern'] = String(base.pattern);
  if (logo.type && logo.type !== 'None') props['Logo Type'] = String(logo.type);
  if (logo.name) props['Logo Name'] = String(logo.name);
  if (logoColors.length === 1) props['Logo Color'] = String(logoColors[0]);
  else if (logoColors.length === 2) props['Logo Color'] = logoColors.join(' | ');

  return props;
}

function buildForgeProperties3() {
  const d = window.orderData || {};
  const base = d.basePaint || {};
  const logo = d.logo || {};
  const img  = d.img  || {};

  const baseColors = [base.colorA, base.colorB, base.colorC].filter(c => c && c !== 'null');
  const logoColors = [logo.colorA, logo.colorB].filter(c => c && c !== 'null');

  const material =
    typeof d.material === 'string' && d.material.length
      ? d.material.charAt(0).toUpperCase() + d.material.slice(1)
      : '';

  const payload = {
    product: d.product,
    diameter: d.diameter,
    thickness: d.thickness,
    material: d.material,
    basePaint: base,
    logo,
    quantity: d.quantity,
    img: {
      screenshot1: img.screenshot1 || null,
      screenshot2: img.screenshot2 || null
    },
    uploads: d.uploadURLs || []   // URLs from handleUploads (logo + snaps)
  };

  const props = {
    _forge_payload: JSON.stringify(payload)  // hidden by most cart templates
  };

  // Material (capitalized)
  if (material) {
    props['Forge Material'] = material;
  }

  // Base Color(s)
  if (baseColors.length > 0) {
    if (!base.pattern || base.pattern === 'None') {
      // Pattern = None → only first color
      props['Base Color'] = String(baseColors[0]);
    } else {
      // Pattern present → all colors
      props['Base Color'] = baseColors.join(' | ');
    }
  }

  // Base Pattern (only if not None)
  if (base.pattern && base.pattern !== 'None') {
    props['Base Pattern'] = String(base.pattern);
  }

  // Logo type and name (skip "None")
  if (logo.type && logo.type !== 'None') {
    props['Logo Type'] = String(logo.type);
  }
  if (logo.name) {
    props['Logo Name'] = String(logo.name);
  }

  // Logo Color(s)
  if (logoColors.length === 1) {
    props['Logo Color'] = String(logoColors[0]);
  } else if (logoColors.length === 2) {
    props['Logo Color'] = logoColors.join(' | ');
  }

  // Upload URLs (logo + screenshots) if you’ve set them on orderData.uploadURLs
  if (d.uploadURLs && d.uploadURLs.length) {
    props['Forge Uploads'] = d.uploadURLs.join(' | ');
  }

  return props;
}

// Add to Cart Helper
async function addToCart(variantId, quantity, properties = {}) {
  const body = {items: [{id: variantId,quantity,properties}]};
  const res = await fetch('/cart/add.js', {
    method: 'POST', 
    headers: {
        'Content-Type': 'application/json', 
        'Accept': 'application/json'
    }, 
    body: JSON.stringify(body)
  });
  if (!res.ok) throw new Error('Cart add failed');
  return res.json();
}
async function uploadImageToShopifynew(source, filename = 'forge_upload.png') {
  let blob;

  if (typeof source === 'string') {
    // dataURL
    blob = dataURLtoBlob(source);
  } else if (source instanceof Blob) {
    blob = source;
  } else {
    throw new Error('uploadImageToShopify: invalid source');
  }

  const fd = new FormData();
  fd.append('file', blob, filename);

  const res = await fetch('/file_uploads', {
    method: 'POST',
    body: fd
  });

  if (!res.ok) throw new Error('Upload failed');
  const json = await res.json();
  return json?.files?.[0]?.url || null;
}

async function uploadImageToShopify(dataUrl, filename = 'forge_upload.png') {
  const blob = dataURLtoBlob(dataUrl);
  const fd = new FormData();
  fd.append('file', blob, filename);

  const res = await fetch('/file_uploads', {
    method: 'POST',
    body: fd
  });

  if (!res.ok) throw new Error('Upload failed');
  const json = await res.json();

  // The CDN URL looks like:
  // https://cdn.shopify.com/s/files/.../forge_upload.png
  return json?.files?.[0]?.url || null;
}


function dataURLtoBlob(dataurl) {
  const [meta, content] = dataurl.split(',');
  const mime = meta.match(/:(.*?);/)[1];
  const bin = atob(content);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new Blob([arr], { type: mime });
}
async function handleUploads() {
  const d = window.orderData || {};
  const urls = [];

  // Logo blob (already stored on orderData.logo.upload)
  if (d.logo && d.logo.upload) {
    // optional: compress logo too if needed
    const logoUrl = await uploadImageToShopify(d.logo.upload, '//baronofdice.com/cdn/shop/files/bod_default_logo.png?v=1763738548');
    if (logoUrl) urls.push(logoUrl);
  }

  // Screenshots (dataURL strings)
  const s1 = d.img?.screenshot1;
  const s2 = d.img?.screenshot2;

  if (s1) {
    const smallBlob1 = await shrinkImage(s1);           // Blob (jpeg)
    const u1 = await uploadImageToShopify(smallBlob1, 'forge_snap1.jpg');
    if (u1) urls.push(u1);
  }

  if (s2) {
    const smallBlob2 = await shrinkImage(s2);           // Blob (jpeg)
    const u2 = await uploadImageToShopify(smallBlob2, 'forge_snap2.jpg');
    if (u2) urls.push(u2);
  }

  d.uploadURLs = urls;
  window.orderData = d;
  return urls;
}

async function shrinkImage(dataURL, maxWidth = 120, quality = 0.8, type = 'image/png') {
  const img = new Image();
  img.src = dataURL;
  await img.decode();

  const scale = Math.min(1, maxWidth / img.width);
  const canvas = document.createElement('canvas');
  canvas.width = img.width * scale;
  canvas.height = img.height * scale;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  return new Promise(res =>
    canvas.toBlob(b => res(b), type)
    // canvas.toBlob(b => res(b), type, quality) // convert PNG→JPEG, compress
  );
}

// 11-28 upload test
async function addToCartWithUploads(variantId) {
  const d = window.orderData || {};

  const form = document.createElement('form');
  form.action = '/cart/add';
  form.method = 'POST';
  form.enctype = 'multipart/form-data';
  form.style.display = 'none';

  // Variant
  const variantInput = document.createElement('input');
  variantInput.type = 'hidden';
  variantInput.name = 'id';
  variantInput.value = variantId;
  form.appendChild(variantInput);

  // Quantity
  const qtyInput = document.createElement('input');
  qtyInput.type = 'hidden';
  qtyInput.name = 'quantity';
  qtyInput.value = 1;
  form.appendChild(qtyInput);

// Properties (original lineup)
  const props = buildForgePropertiesOriginal();
  Object.entries(props).forEach(([key, val]) => {
    if (val == null || val === '') return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[${key}]`;
    input.value = String(val);
    form.appendChild(input);
  });

  // === 3 FILE INPUTS ===
  const files = [];

    // 1) User uploaded logo (from the file input)
    const logoInput = document.getElementById('artFile');
    if (logoInput && logoInput.files && logoInput.files.length > 0) {
    const logoFile = logoInput.files[0];
    files.push({
        blob: logoFile,
        name: logoFile.name || 'forge_logo.png',
        label: 'Logo Upload'
    });
    }

  // 2) Screenshot 1 (dataURL -> compressed JPEG blob)
  if (d.img && d.img.screenshot1) {
    const blob1 = await shrinkImage(d.img.screenshot1, 1200, 0.075);
    files.push({
      blob: blob1,
      name: 'forge_snap1.jpg',
      label: 'Screenshot 1'
    });
  }

  // 3) Screenshot 2 (dataURL -> compressed JPEG blob)
  if (d.img && d.img.screenshot2) {
    const blob2 = await shrinkImage(d.img.screenshot2, 400, 0.75);
    files.push({
      blob: blob2,
      name: 'forge_snap2.jpg',
      label: 'Screenshot 2'
    });
  }

  files.forEach(f => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.name = `properties[${f.label}]`;

    const dt = new DataTransfer();
    dt.items.add(new File([f.blob], f.name, { type: f.blob.type || 'image/png' }));
    // dt.items.add(new File([f.blob], f.name, { type: f.blob.type || 'image/jpeg' }));
    fileInput.files = dt.files;

    form.appendChild(fileInput);
  });

  document.body.appendChild(form);
  form.submit();
}
function buildLightForgePayload(d = window.orderData || {}) {
  const base = d.basePaint || {};
  const logo = d.logo || {};

  const baseColors = [base.colorA, base.colorB, base.colorC].filter(
    c => c && c !== 'null'
  );
  const logoColors = [logo.colorA, logo.colorB].filter(
    c => c && c !== 'null'
  );

  return {
    product: d.product || null,
    diameter: d.diameter || null,
    thickness: d.thickness || null,
    material: d.material || null,
    quantity: d.quantity || null,
    basePaint: {
      pattern: base.pattern || null,
      colors: baseColors
    },
    logo: {
      type: logo.type || null,
      name: logo.name || null,
      colors: logoColors
    }
    // ❌ NO screenshot1 / screenshot2 / File blobs in here
  };
}

function initAddToCartButton2() {
  const btn = document.getElementById('add2cart');
  if (!btn) return;

  btn.addEventListener('click', async () => {
    const sel = getSelectedVariantFromSlider();
    if (!sel?.variant) return;

    const d = window.orderData || {};
    d.quantity = sel.qty;

    // optional: compress screenshots first with shrinkImage()
    await addToCartWithUploads(sel.variant.id, d);
  });
}
function initAddToCartButton() {
  // no DOM listener here – just expose a function
  window.forgeAddToCart = async () => {
    const sel = getSelectedVariantFromSlider();
    if (!sel || !sel.variant) return;

    if (!window.orderData) window.orderData = {};
    window.orderData.quantity = sel.qty;

    try {
      await addToCartWithUploads(sel.variant.id);
    } catch (err) {
      console.error('Add to Cart failed:', err);
    }
  };
}

function buildForgePropertiesOriginal() {
  const d    = window.orderData || {};
  const base = d.basePaint || {};
  const logo = d.logo || {};
  const img  = d.img  || {};

  const baseColors = [base.colorA, base.colorB, base.colorC].filter(
    c => c && c !== 'null'
  );
  const logoColors = [logo.colorA, logo.colorB].filter(
    c => c && c !== 'null'
  );

  const material =
    typeof d.material === 'string' && d.material.length
      ? d.material.charAt(0).toUpperCase() + d.material.slice(1)
      : '';

  const payload = {
    product: d.product,
    diameter: d.diameter,
    thickness: d.thickness,
    material: d.material,
    basePaint: base,
    logo,
    quantity: d.quantity
    // no screenshots or blobs in here – keep it light
  };

  const props = {
    _forge_payload: JSON.stringify(payload)
  };

  if (material) {
    props['Forge Material'] = material;
  }

  if (baseColors.length > 0) {
    if (!base.pattern || base.pattern === 'None') {
      props['Base Color'] = String(baseColors[0]);
    } else {
      props['Base Color'] = baseColors.join(' | ');
    }
  }

  if (base.pattern && base.pattern !== 'None') {
    props['Base Pattern'] = String(base.pattern);
  }

  if (logo.type && logo.type !== 'None') {
    props['Logo Type'] = String(logo.type);
  }

  if (logo.name) {
    props['Logo Name'] = String(logo.name);
  }

  if (logoColors.length === 1) {
    props['Logo Color'] = String(logoColors[0]);
  } else if (logoColors.length === 2) {
    props['Logo Color'] = logoColors.join(' | ');
  }

  // Can't know the CDN URLs at this point, so Forge Uploads
  // will be provided by the individual Forge Upload N properties
  // that Shopify creates from the file inputs.

  return props;
}
